// Tiny host helper for the iRacing OAuth flow.
//
// The local iRacing redirect URI registered with iRacing is
// http://127.0.0.1:3100/api/auth/iracing/callback (NOT localhost). The
// backend's getRedirectUri(req) checks req.get("host") to decide which
// redirect URI to send to iRacing, so in dev the frontend MUST initiate
// the OAuth flow against http://127.0.0.1:3100.
//
// This file is the ONLY place that picks dev vs prod backend hosts for
// the iRacing-auth-related code. Existing components keep their
// hardcoded API URLs.

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

export const IRACING_PROD_API_BASE = "https://iracing6-backend.herokuapp.com";

export const IRACING_AUTH_API_BASE = isLocalHost
  ? "http://127.0.0.1:3100"
  : IRACING_PROD_API_BASE;

export const IRACING_AUTH_LOGIN_URL = `${IRACING_AUTH_API_BASE}/api/auth/iracing/login`;
